export const mediaUploader = {
  uploadSize: 'File is greater than 2Mb. Please reduce the file size',
  filesAllowed: `Total media files allowed with current subscription is:`,
};
